import ClimateChangeStructureCheckbox from './ClimateChangeStructureCheckbox';

export default ClimateChangeStructureCheckbox;
